import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: () =>
        import(/* webpackChunkName: "index" */ "@/views/Index.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login-new" */ "@/views/Login-new.vue"),
    },
    {
      path: "/register",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/Register.vue"),
    },
    {
      path: "/search",
      name: "search",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/Search.vue"),
    },
    {
      path: "/404",
      name: "notFound",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/Error.vue"),
    },
    {
      path: "*",
      redirect: { name: "index" },
    },
  ],
});
let isFetchBrand = false;
router.beforeEach(async (to, from, next) => {
  const hosts = window.location.host.split(".");
  const brandName =
    "development" === process.env.NODE_ENV ? "brand" : hosts[hosts.length - 3];
  const store = router.app.$options.store;
  if (!isFetchBrand) {
    try {
      const resp = await store.dispatch("siteBrand/setupBrand", brandName);
      const isDisabled = store.getters["siteBrand/isDisabled"];
      isFetchBrand = true;
      const { data } = resp;
      if (!data.length || isDisabled) {
        return next({
          name: "notFound",
        });
      }
    } catch (error) {}
  }

  if (
    ~["site", "register"].indexOf(to.name) &&
    store.getters["siteBrand/isTypeNoOne"]
  ) {
    return next({
      name: "login",
    });
  }
  next();
});
router.afterEach((to, from) => {
  const store = router.app.$options.store;
  const brandTitle = store.state.siteBrand.title;
  if (brandTitle) {
    document.title = brandTitle;
  }
});

export default router;
